import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { requestSupplierPostApi } from "../../Api/SupplierServices";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Style from "./RequestForSupplier.module.css";
const RequestForSupplier = () => {
  const [type, setType] = useState();
  const [categoryChoosen, setCategoryChoosen] = useState();
  const [categoryList, setCategoryList] = useState([]);
  
  const [chooseCity, setChooseCity] = useState();
  const history=useHistory()
  const data = [
    {
      value: "1",
      label: "رستوران",
      type:"food"
    },
    {
      value: "2",
      label: "فروشگاه",
      type:"supermarket"
    },
  ];
  const category=[
    {
      value:"1",
      label:"کبابی",
      parent:"1"
    },{
      value:"2",
      label:"ساندویچی",
      parent:"1"
    },{
      value:"3",
      label:"قهوه خانه",
      parent:"1"
    },{
      value:"4",
      label:"هتل",
      parent:"1"
    },{
      value:"5",
      label:"آشپزخانه",
      parent:"1"
    },{
      value:"6",
      label:"کافه",
      parent:"1"
    },{
      value:"6",
      label:"لوازم خانگی",
      parent:"2"
    },{
      value:"6",
      label:"سوپرمارکت",
      parent:"2"
    }
  ]
  const city = [
    {
      value: "1",
      label: "بهشهر",
      cityId: "4851",
    },
    {
      value: "2",
      label: "گلوگاه",
      cityId: "4861",
    },
    {
      value: "3",
      label: "نکا",
      cityId: "4841",
    },
  ];
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const chooseTypeOnChange=(val)=>{
    setType(val)
    category.forEach(element => {
      if(element.parent === val.value){
        setCategoryList((prev)=>[...prev , element])
        // array.push(element.label)
        // console.log(element)
      }
    });
  }
  const onsubmit = (data) => {
    let info = {
      first_name: data.fName,
      last_name: data.lName,
      phone: data.phone,
      name: data.supplierName,
      address: data.address,
      email: data.email ? data.email : "",
      telephone: data.telephone ? data.telephone : "",
      city_id: chooseCity.cityId,
      type: type.type,
      category:categoryChoosen.label,
    };
    requestSupplierPostApi(info,res=>{
      history.push("/login")
    })
  };
  return (
    <div className={Style.componentHolder}>
      <MenuTitle title={"ثبت نام برای شروع همکاری "} />
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formHolder}>
        <input
          {...register("fName", { required: true })}
          className={errors.fName ? Style.errorInput : Style.input}
          placeholder="نام"
        />
        <input
          {...register("lName", { required: true })}
          className={Style.input}
          placeholder=" نام خانوادگی"
        />
        <input
          {...register("supplierName", { required: true })}
          className={Style.input}
          placeholder="نام برند کسب و کار"
        />
        <input
          {...register("phone", { required: true })}
          className={Style.input}
          placeholder="شماره همراه"
        />
        <Select
          onChange={setChooseCity}
          options={city}
          placeholder={" شهر"}
          className={Style.selectPart}
        />
        <Select
          onChange={chooseTypeOnChange}
          options={data}
          placeholder={"نوع کسب وکار"}
          className={Style.selectPart}
        />
        <Select
          onChange={setCategoryChoosen}
          options={categoryList}
          placeholder={"دسته بندی"}
          className={Style.selectPart}
          isDisabled={type?false:true}
        />
        <input
          {...register("address", { required: true })}
          className={Style.input}
          placeholder="آدرس"
        />
        <input
          {...register("telephone")}
          className={Style.input}
          placeholder="شماره ثابت"
        />
        <input
          {...register("email")}
          className={Style.input}
          placeholder="ایمیل"
        />
        <div className={Style.btnHolder}>
          <button type={"submit"} className={Style.btnRequest}>
            ارسال درخواست
          </button>
        </div>
      </form>
    </div>
  );
};

export default RequestForSupplier;
